import { IndicatorScore, Organization } from '@/api/';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import { useStore } from '@nanostores/react';
import { Badge, Loader2, Play, CheckCircle, XCircle } from 'lucide-react';
import { DeleteIndicatorScoreConfirmation } from './DeleteIndicatorScoreConfirmation'; 
import { cn } from '@/lib/utils';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
/**
 * We'll update the selected project in the store and route
 * to the project page.
 */
function handleSelectIndicatorScore(
  organization: Organization,
  indicatorscore: IndicatorScore,
) {
  console.log('Indicator Score:');
  console.log(indicatorscore);
  $indicatorscore.set(indicatorscore);

  openPage($router, 'indicatorscore', {
    organizationId: organization.id,
    indicatorscoreId: indicatorscore.id,
  });
}

export const IndicatorScoreListing = () => {
  const org = useStore($org);

  const indicatorscores = useStore($indicatorscores);
  const loadingIndicatorScores = useStore($loadingIndicatorScores);

  const sortedIndicatorScores = indicatorscores
    ?.slice()
    ?.sort(
      (a, b) =>
        new Date(b.createdAtUtc).getTime() - new Date(a.createdAtUtc).getTime(),
    );

  const [isDeleteIndicatorScoreModalOpen, setIsDeleteIndicatorScoreModalOpen] =
    useState(false);
  const [indicatorScoreToBeDeleted, setIndicatorScoreToBeDeleted] = useState('');

  const selectedIndicatorScore = useStore($indicatorscore);
  
  // Handle empty state when no account receivables exist
  if (!loadingIndicatorScores && (!indicatorscores || indicatorscores.length === 0)) {
    return (
      <div className="flex h-32 items-center justify-center">
        <p>No indicator scores found.</p>
      </div>
    );
  }

  const formatDateString = (date: string | Date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };


  function getDateRangeString(
    startDate: string | Date,
    endDate: string | Date,
  ) {
    const startDateString = formatDateString(startDate);

    const endDateString = formatDateString(endDate);

    if (startDateString === endDateString) {
      return `for ${startDateString}`;
    } else {
      return `between ${startDateString} and ${endDateString}`;
    }
  }


  return (
    <>
      {loadingIndicatorScores ? (
        <div className="flex h-32 items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      ) : (
        <div className="rounded-md border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Account Name</TableHead>
                <TableHead>Account ID</TableHead>
                <TableHead>Portfolio Name</TableHead>
                <TableHead>Current Score</TableHead>
                <TableHead className="text-right">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {sortedIndicatorScores?.map((indicatorscore) => (
                <TableRow key={indicatorscore.id}>
                  <TableCell>{indicatorscore.accountReceivable?.name}</TableCell>
                  <TableCell>{indicatorscore.accountReceivableId}</TableCell>
                  <TableCell>{indicatorscore.accountReceivable?.portfolio?.name}</TableCell>
                  <TableCell>{indicatorscore.currentScore}</TableCell>
                  <TableCell className="text-right">
                    <div className="flex items-center justify-end gap-2">
                      <Button
                        variant="outline"
                        onClick={() => {
                          if (org) handleSelectIndicatorScore(org, indicatorscore);
                        }}
                      >
                        View Score History
                      </Button>
                      <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                          <Button variant="outline" size="icon">
                            <EllipsisVerticalIcon className="h-4 w-4" />
                          </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent>
                          <DropdownMenuLabel>Options</DropdownMenuLabel>
                          <DropdownMenuSeparator />
                          <DropdownMenuItem
                            onClick={() => {
                              setIndicatorScoreToBeDeleted(indicatorscore.id);
                              setIsDeleteIndicatorScoreModalOpen(true);
                            }}
                          >
                            Delete Indicator Score
                          </DropdownMenuItem>
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
  
      <DeleteIndicatorScoreConfirmation
        isOpen={isDeleteIndicatorScoreModalOpen}
        handleOpen={setIsDeleteIndicatorScoreModalOpen}
        indicatorscoreId={indicatorScoreToBeDeleted}
      />
    </>
  );
};
